export const COMP_INTEL_FEATURE_COUNT = 4;
export const COMP_INTEL_SEO_FEATURE_COUNT = 9;
export const TRIAL_EXTENSION_DAYS = 6;

export const TRACKING_EVENTS = {
    category: "Package",
    actionShow: "show",
    actionClick: "click",
} as const;

export const TRANSLATION_KEYS = {
    title: "pro.packages.v2.title",
    skipTrialTitle: "pro.packages.skip.title",
    subtitle: "pro.packages.subtitle",
    compIntelTitle: "pro.packages.comp_intel.title",
    compIntelSubtitle: "pro.packages.comp_intel.subtitle",
    compIntelItems: "pro.packages.comp_intel",
    compIntelSeoTitleSuffix: "pro.packages.comp_intel_seo.title_suffix",
    compIntelAeoTitleSuffix: "pro.packages.comp_intel_aeo.title_suffix",
    compIntelSeoSubtitle: "pro.packages.comp_intel_seo.subtitle",
    compIntelSeoItems: "pro.packages.comp_intel_seo",
    textPrice: "pro.packages.text_price",
    startsFrom: "pro.packages.starts_from",
    recommendedText: "pro.packages.recommended.text",
    buttonText: "pro.packages.button.text",
} as const;
